import { Show, createMemo, type ParentProps } from "solid-js"
import { useAuth } from "@/context/auth"
import { claimDeviceState } from "@/storage/workspace-owner"

export function SessionVerification(props: ParentProps) {
  const auth = useAuth()
  // This browser's stored state must belong to the signed-in account before
  // anything below reads it.
  const verified = createMemo(() => {
    const user = auth.user()
    if (user) claimDeviceState(user.id)
    return !!user || auth.status() === "unauthenticated"
  })
  return (
    <Show when={verified()} fallback={
      <main class="flex min-h-dvh items-center justify-center bg-background-base p-6 text-text-base">
        <section class="flex max-w-md flex-col items-center gap-4 text-center" aria-live="polite">
          <Show when={auth.status() === "unavailable"} fallback={<p>Restoring your session…</p>}>
            <h1 class="text-xl font-medium">Couldn’t verify your session</h1>
            <p>Kettle could not reach your account. You have not been signed out. Retrying automatically.</p>
            <button class="rounded-md border border-border-base px-4 py-2" onClick={() => void auth.refresh()}>Retry connection</button>
          </Show>
        </section>
      </main>
    }>
      <Show when={auth.status() === "unavailable"}>
        <div role="status" class="border-b border-border-base bg-background-base px-4 py-2 text-text-base">
          Account connection interrupted. Retrying session verification.
          <button class="ml-3 underline" onClick={() => void auth.refresh()}>Retry now</button>
        </div>
      </Show>
      {props.children}
    </Show>
  )
}
